import OLMap from 'ol/Map';
import DragPan from 'ol/interaction/DragPan';

export function getDragPan(map: OLMap) {
  const interactions = map.getInteractions();

  for (let i = 0; i < interactions.getLength(); i++) {
    const interaction = interactions.item(i);
    if (interaction instanceof DragPan) {
      return interaction;
    }
  }

  return null;
}
